<template>
  <div class="order-confrim">
    <close title="订单确认" @close="goabck"></close>

    <!-- 商品列表 -->
    <div class="order-confrim-wrapper">
      <div class="order-platform">
        <div class="order-platform-wrapper">
          <div class="platform-title van-hairline--bottom">
            以下商品由
            <em>{{hornorConfrimOrder.platform_info.brand}}</em> 提供供应链支持
          </div>
          <div class="platform-sku-list" >
            <a href="javascript:;" class="jump-details" @click="jumpDetails">
              <div class="sku-imgs">
                <img
                class="van-hairline--surround"
                v-lazy="hornorConfrimOrder.pic_url"
               >
                <span class="problem-mask" v-show="hornorConfrimOrder.problemHint">{{hornorConfrimOrder.problemHint}}</span>
              </div>
              <span class="tips">共1件<svg t="1563528541213" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1855" width="12" height="12"><path d="M475.52 13.504l497.728 497.728-498.496 498.496-45.248-45.248 453.248-453.248L430.144 58.752z" p-id="1856" fill="#404040"></path><path d="M112 13.504l497.728 497.728-498.496 498.496-45.248-45.248 453.248-453.248-452.48-452.48z" p-id="1857" fill="#404040"></path></svg></span>
            </a>
          </div>
          <div class="fill-address van-hairline--bottom" v-if="!hornorConfrimOrder.userAddress && hornorConfrimOrder.needAddress">
            <button @click="fillAddressHandler(hornorConfrimOrder.platform_info)">请完善收货地址</button>
          </div>
          <div class="platform-address" v-else-if="hornorConfrimOrder.userAddress && hornorConfrimOrder.needAddress">
            <order-address
              :platform="hornorConfrimOrder.platform_info"
              :address="hornorConfrimOrder.userAddress"
              @edit="fillAddressHandler(hornorConfrimOrder.platform_info)"
              :showEdit="true"></order-address>
          </div>
        </div>
      </div>
    </div>

    <div class="shoping-trolley-footer van-hairline--top">
      <div class="product-total-price">
        <div class="total-price">
          <div class="total">
            <span>实付金额: </span>
            <div class="price">
              ¥<em>{{hornorConfrimOrder.equity.discount}}</em>
            </div>
          </div>
          <div class="shop-wealfare">优惠：¥{{hornorConfrimOrder.equity.discount | diffPrice(hornorConfrimOrder.market_price)}} </div>
        </div>
        <div class="settle-accounts">
          <button class="submit" :class="{'cannot-submit': canSubmit}" @click="settleAccounts">去结算</button>
        </div>
      </div>
    </div>
    <user-dialog :show="dialog.show" @cancel-handler="cancelHandler" @confrim-handler="confrimHandler">
      <template #msg>
        {{dialog.text}}
      </template>
    </user-dialog>
  </div>
</template>

<script>
import Close from '../../components/Close'
import OrderAddress from '../../components/OrderAddressChange'
import UserDialog from '../../components/Dialog'
import { mapState } from 'vuex'
import Big from 'big.js'
const init = new Big(0)
export default {
  name: 'orderConfrim',
  components: {
    Close,
    OrderAddress,
    UserDialog
  },
  data () {
    return {
      dialog: {
        show: false,
        text: '选了这么久, 确认要退出么?'
      }
    }
  },
  filters: {
    diffPrice (discountPrice, marketPrice) {
      return init.plus(marketPrice).minus(discountPrice).toFixed(2)
    }
  },
  computed: {
    ...mapState('hornorBuy', [
      'hornorConfrimOrder'
    ]),
    skuInfo () {
      return this.$route.query
    },
    canSubmit () {
      if (this.hornorConfrimOrder.needAddress) {
        if (this.hornorConfrimOrder.userAddress) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }
  },
  created () {
  },
  methods: {

    /**
     * 返回上一级
    */
    goabck () {
      this.dialog.show = true
    },

    /**
     * 弹窗 取消
    */
    cancelHandler () {
      this.dialog.show = false
    },

    /**
     * 弹窗确认
    */
    confrimHandler () {
      this.$router.back()
      this.dialog.show = false
    },
    /**
     * 填写地址
    */
    fillAddressHandler (platform) {
      this.$router.push({ name: 'userAddressManager', query: { callback: 'hornorBuyGoodsOrder', ...platform } })
    },

    /**
     * 用户修改地址库存查询
    */
    async checkInventory (platform) {
      const order = {}
      order[platform] = {}
      order[platform].sku = []
      order[platform].address = {}
      this.confrimOrderList.forEach(platformInfo => {
        if (platformInfo.platform.name === platform) {
          order[platform].address = platformInfo.userAddress
          platformInfo.sku_list.forEach(sku => {
            order[platform].sku.push(sku.sku_id)
          })
        }
      })
      const res = await this.$axios.post('api/order/check', { ...order })
      if (res.status === 200) {
        const { code, data, msg } = res.data
        if (code === 0) {
          this.getPlatformFreight(data)
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 去结算 下单
    */
    async settleAccounts () {
      if (this.canSubmit) {
        this.$toast('请完善收货地址')
        return false
      }
      this.$toast.loading('正在下单,请稍后...')
      const res = await this.$axios.post('api/business/order', {
        gid: this.skuInfo.aid,
        sku_id: this.hornorConfrimOrder.sku_id,
        address_id: this.hornorConfrimOrder.userAddress.id })
      if (res.status === 200) {
        this.$toast.clear()
        const { code, data, msg } = res.data
        if (code === 0) {
          const { sign, tradeId, redirect } = data
          if (sign === 'order') {
            this.$toast('下单成功')
            setTimeout(() => {
              this.$router.push({ name: 'orderDetails', query: { orderid: tradeId } })
            }, 1500)
          } else if (sign === 'pay') {
            location.href = redirect
          }
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 平台订列表详情
    */
    jumpDetails () {
      this.$router.back()
    }
  }

}
</script>

<style lang="less" scoped>
 @keyframes mymove {
    0%{
    transform: scale(1);  /*开始为原始大小*/
    }
    25%{
        transform: scale(0.9); /*放大1.1倍*/
    }
    50%{
        transform: scale(1);
    }
    75%{
        transform: scale(0.9);
    }
    100% {
      transform: scale(1);
    }

}
.order-confrim {
  padding: 0 0 1.5rem;
  .order-confrim-wrapper {
    padding: 0 0 0.2rem;
    .order-platform {
      margin-top: 0.2rem;
      background-color: #fff;
      padding: 0 0.2rem 0.3rem;
      // padding-bottom: 0.2rem;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.22);
      // border-radius: 0.12rem;
      .platform-title {
        position: relative;
        height: 0.93rem;
        display: flex;
        align-items: center;
        font-size: @fz28;
        color: @base;
        padding-left: 0.82rem;
        em {
          font-weight: 700;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0.23rem;
          width: 0.45rem;
          height: 0.35rem;
          background: url("../../assets/img/cargo-van.png") center no-repeat;
          background-size: 100%;
        }
      }
      .fill-address {
        height: 0.8rem;
        padding: 0.3rem 0.32rem;
        button {
          width: 100%;
          height: 100%;
          border: 0.02rem solid #ff2851;
          color: #ff2851;
          font-size: @fz34;
          font-weight: 700;
          border-radius: 30px;
          animation:mymove 3s infinite;
        }

      }
      .platform-address {
        padding: 0.32rem 0.24rem 0;
      }
    }
    .platform-sku-list {
      padding-top: 0.2rem;
      height: 1.8rem;
      .flex-center;
      .jump-details {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #F2F2F2;
        display: flex;
        align-items: center;
        .sku-imgs {
          position: relative;
          width: 1.4rem;
          height: 1.4rem;
          margin-left: 0.24rem;
          background-color: #fff;
          img {
            object-fit: contain;
          }
          .problem-mask {
            position: absolute;
            width: 60%;
            height: 60%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .flex-center;
            font-size: @fz26;
            color: #fff;
            background-color: rgba(0,0,0,0.7);
            border-radius: 50%;
          }
        }

        .tips {
          position: absolute;
          right: 0.3rem;
          font-size: @fz24;
          color: @base;
          margin-left: 0.3rem;
          white-space: nowrap;
          .flex-center;
        }
      }

    }
    .platform-freight {
      margin-top: 0.17rem;
      font-size: @fz28;
      color: @base;
      text-align: right;
      em {
        color: @price;
      }
    }
  }
  .order-intro {
    .order-price, .freight{
      padding: 0 0.35rem;
      height: 0.8rem;
      border-bottom: 0.5px solid #D2D2D2;
      box-sizing: border-box;
      background-color: #fff;
      font-size: @fz28;
      display: flex;
      align-items: center;
    }
    .freight, .order-price {
      justify-content: space-between;
    }
    .freight {
      .freight-tips {
        .flex-center;
      }
      .tips {
        display: inline-block;
        margin-left: 0.1rem;
        width: 0.39rem;
        height: 0.39rem;
        background: url('../../assets/img/tips.png') center no-repeat;
        background-size: 100%;
      }
      span:nth-child(2) {
        color: #FF9600;
      }
    }
    // .open-member {
    //   padding-left: 0.2rem;
    //   height: 1.3rem;
    //   background-color: #fff;
    //   font-size: @fz28;
    //   font-weight: 660;
    //   display: flex;
    //   justify-content: center;
    //   flex-direction: column;
    //   margin-bottom: 0.4rem;
    //   .member-intro {
    //     display: flex;
    //     align-items: center;
    //     p {
    //       padding-left: 0.32rem;
    //     }
    //   }
    //   em {
    //     color: @price;
    //   }
    //   .member-price {
    //     padding-left: 0.63rem;
    //     padding-top: 0.08rem;
    //     color: @c80;
    //   }
    // }
  }
  .open-member {
    position: relative;
    width: 6.9rem;
    height: 1.55rem;
    margin: 0.58rem auto 0;
    background:linear-gradient(180deg,rgba(30,62,117,1) 0%,rgba(18,33,57,1) 100%);
    border-radius:0.1rem;
    font-size: @fz28;
    font-weight: 660;
    color: #fff;
    &::before {

    }
   .flex-between;
    margin-bottom: 0.4rem;
    .member-intro {
      display: flex;
      flex-direction: column;
      p {
        padding-left: 0.32rem;
        em {
          color: #FF9600;
        }
      }
    }
    button {
      margin-right: 0.26rem;
      width: 1.96rem;
      height: 0.78rem;
      background-color: #F1C40F;
      border-radius: 30px;
      font-size: 0.32rem;
      color: #B53900;
    }

  }
  .shoping-trolley-footer {
    position: fixed;
    bottom: 0;
    background-color: #fff;
    width: 100%;
    height: 1.2rem;
    .flex-between;
    font-size: @fz28;
    .product-total-price {
      .flex-between;
      height: 100%;
      .total-price {
        width: 5.34rem;
        padding-left: 0.44rem;
        display: flex;
        flex-direction: column;

      }
      .total {
        color: @base;
        display: flex;
        font-weight: 660;
        span {
          padding-right: 0.3rem;
        }
        .price {
          color: @price;
          font-size: @fz22;
          em {
            font-size: @fz32;
          }
        }
      }
      .shop-wealfare {
        font-size: @fz22;
        color: #ff7163;
      }
    }
    .settle-accounts {
      width: 1.72rem;
      height: 100%;

      color: #fff;
      .flex-center;
      button {
        width: 100%;
        height: 100%;
        background-color: #ff3824;
        &:disabled {
          background-color: #333;
        }
      }
      .cannot-submit {
        background-color: #333;
      }

    }
  }
  .freight-tips-desc{
    padding-top: 0.45rem;
    h2 {
      font-size: @fz32;
      color: @base;
      font-weight: bold;
      padding-left: 0.38rem;
      border-left: 0.07rem solid #FF4141;
    }
    p {
      padding: 0.2rem 0.31rem 0.4rem;
    }
  }
}
</style>
